import React, { useRef } from 'react';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';

import { UserReviewInviteConfirm, UserReviewInviteConfirmVariables } from './__generated__/UserReviewInviteConfirm';

import { LayoutDefault, Loading } from '../../shared/ui';
import { useQueryParams } from '../../shared/router';
import { auth } from '../../shared/auth';
import { useResetCurrentUserAndHistoryPush } from '../../shared/user';

const PATH_INVITE_CONFIRM_LANDING = '/profyle-review/to-review';

const USER_Review_INVITE_CONFIRM = gql`
  mutation UserReviewInviteConfirm($input: UserInviteConfirmInput!) {
    userReviewInviteConfirm(input: $input) {
      token
    }
  }
`;

function Invite() {
  const queryParams = useQueryParams();
  const code = queryParams.get('code');
  if (!code) {
    throw new Error('Code is not found in query params');
  }
  const resetCurrentUserAndHistoryPush = useResetCurrentUserAndHistoryPush();
  const [userReviewInviteConfirm] = useMutation<UserReviewInviteConfirm, UserReviewInviteConfirmVariables>(
    USER_Review_INVITE_CONFIRM
  );
  const ref = useRef<boolean>();

  // Run only on first render
  if (!ref.current) {
    ref.current = true;

    const input = { code };
    userReviewInviteConfirm({ variables: { input: input } }).then((result) => {
      return auth.authenticate(result.data!.userReviewInviteConfirm!.token).then(() => {
        resetCurrentUserAndHistoryPush(PATH_INVITE_CONFIRM_LANDING);
      });
    });
  }

  return (
    <LayoutDefault>
      <h2>Invite</h2>
      <Loading />
    </LayoutDefault>
  );
}

export { Invite };
